import { Link } from 'react-router-dom';

import Picture from '../../Picture/Picture';

import styles from './ThumbNailsMini.module.css';

export interface ThumbNail {
  id: string;
  title: string;
  slug: string;
  src: string;
}

interface Props {
  slug: string;
  src: string;
  alt: string;
}

export default function ThumbNailsMini({ slug, src, alt }: Props) {
  return (
    <Link className={styles.link} to={`/detail/${slug}/`}>
      <Picture className={styles.image} width={1} src={src} alt={alt} />
    </Link>
  );
}
